function About() {
  return (
    <>
      <p id="about-text">
        <span id="about-initials">i</span>saac{" "}
        <span id="about-initials">j</span>enemann is a set designer and
        filmmaker, occasionally a line cook, and always a learner. A background
        in performance paired with hands-on experience in technical direction,
        carpentry, and lighting design informs Isaac’s work and allows a
        practical approach to using space as a storyteller.
        <br />
        <br />
        Please <a className="about-link" href="mailto:isaac.jenemann@gmail.com">email</a>,{" "}
        <a href="sms:+18028817144" className="about-link">
          text
        </a>
        , or <a className="about-link" href="tel:+18028817144">call</a> if you're interested in
        collaborating.
      </p>
      <img id="about-image" src="./Assets/isaac.jpeg" />
    </>
  );
}

export default About;
